var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
import ProfilePic from "@irati/ui/src/ProfilePicture";
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname";
import { IconButton, IconTypes } from "@irati/ui/src/Button";
import { Para } from "@irati/ui/src/Labels";
import id from "@irati/utils/id";
import { greys } from "@irati/ui/src/global/colors";
import padding from "@irati/ui/src/global/padding";
var FlexRow = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-bottom: 1px solid ", ";\n  margin-bottom: ", ";\n  padding-bottom: 10px;\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n"], ["\n  border-bottom: 1px solid ", ";\n  margin-bottom: ", ";\n  padding-bottom: 10px;\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n"])), greys.light, padding.tiny);
var StyledProfilePic = styled(ProfilePic)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-right: 10px;\n"], ["\n  margin-right: 10px;\n"])));
var StyledUser = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: calc(100% - 90px);\n"], ["\n  width: calc(100% - 90px);\n"])));
var StyledButton = styled(IconButton)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 20px;\n"], ["\n  width: 20px;\n"])));
var SelectedUser = /** @class */ (function (_super) {
    __extends(SelectedUser, _super);
    function SelectedUser() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SelectedUser.prototype.render = function () {
        var _a = this.props, removeUser = _a.removeUser, user = _a.user, index = _a.index;
        return (React.createElement(FlexRow, { id: id("recipient" + index, this.props), key: user.uuid },
            React.createElement(StyledProfilePic, { user: user, regular: true }),
            React.createElement(StyledUser, null,
                React.createElement(Para, { large: true }, firstnameLastname(user))),
            React.createElement(StyledButton, { icon: IconTypes.cross, onClick: function () { return removeUser(user); } })));
    };
    SelectedUser.defaultProps = {
        id: "rewardRecipientsList"
    };
    return SelectedUser;
}(PureComponent));
export default SelectedUser;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
